export const RECENT_URL_LIMIT = 5;
const RECENT_URLS_STORAGE_KEY = "capitalrx-rte-recent-urls";

const getStorage = (): Storage | null => {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
};

export const promoteRecentUrl = (recentUrls: readonly string[], rawUrl: string): readonly string[] => {
  const recent = rawUrl.trim();
  if (!recent) return recentUrls;
  return [recent, ...recentUrls.filter((existing) => existing !== recent)].slice(0, RECENT_URL_LIMIT);
};

export const removeRecentUrl = (recentUrls: readonly string[], url: string): readonly string[] => {
  return recentUrls.filter((existing) => existing !== url);
};

export const loadRecentUrls = (): readonly string[] => {
  const storage = getStorage();
  if (storage === null) return [];
  try {
    const raw = storage.getItem(RECENT_URLS_STORAGE_KEY);
    if (raw === null) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((entry): entry is string => typeof entry === "string").slice(0, RECENT_URL_LIMIT);
  } catch {
    return [];
  }
};

export const saveRecentUrls = (recentUrls: readonly string[]): void => {
  const storage = getStorage();
  if (storage === null) return;
  try {
    storage.setItem(RECENT_URLS_STORAGE_KEY, JSON.stringify(recentUrls));
  } catch { }
};
